



























import { Component, Inject, Mixins } from "vue-property-decorator";
import { ModalDialog } from "@apphq/vue-base-components";
import { capitalize, titlecase } from "@apphq/utils";
import I18NextMixin from "../i18n/I18NextMixin";

import ProfileStore from "../ProfileStore";

@Component({
  components: {
    ModalDialog
  },
  filters: {
    capitalize,
    titlecase
  }
})
export default class ProfileDialog extends Mixins(I18NextMixin) {
  @Inject() profileStore!: ProfileStore;

  get user() {
    return {
      userName: this.profileStore.userName,
      loginName: this.profileStore.loginName,
      mail: this.profileStore.userMail
    };
  }

  get company() {
    return this.profileStore.company;
  }
}
